import { useState,useEffect } from "react";
import { GeneralService } from "../../../services/GeneralService";
import { useTranslation } from "react-i18next";
import Select from "../../../components/Select";

export default function CurrentLocation({currentLocation,setCurrentLocation,viewMode}){
  const[countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  let {t} = useTranslation();
  const { i18n } = useTranslation();

  useEffect(() => {   
    GeneralService.getCountries().then((data) => {
        setCountries(data);
  });}, []);

  useEffect(() => {
    let cities=   getCities(currentLocation?.countryId);
    setCities(cities)
  }, [countries]);

  function onChangeCountry(e) {
    const countryId =e.target.value? e.target.value:null;
    let cities=   getCities(countryId);
    setCities(cities);
    setCurrentLocation({...currentLocation,countryId:countryId,cityId:null});
  }

  function getCities(countryId) {
      return  countries.filter((item) => item.id == countryId).map((item) => 
      item.cities
    ).shift()??[];
  }

  function onChangeCity(e) { 
      const cityId =e.target.value? e.target.value:null;
      setCurrentLocation({...currentLocation,cityId:cityId});
  }

  function citySalaryLocationPosition() {
    if(i18n.language === "PT"){
        return "margin-edit-pt";
    }else if (i18n.language === "EN"){
        return "margin-edit-en";
    }else if(i18n.language === "FR"){
        return "margin-edit-fr";
    }else if(i18n.language === "ES"){
        return "margin-edit-es";
    }
  }

  return  <div className="row"> <div className="col-md-6">
    <div className="form-group">
      <div className="label-wrapper">
        {window.location.pathname.includes("createOrEdit") === true ? (
          <label htmlFor="personalDetailLabelZone">{t("Country")}</label>
        ) : (
          <legend className="fontsize-legend">{t("Country")}</legend>
        )}
      </div>
      <Select
        required
        id="countryId"
        name="CountryId"
        onChange={onChangeCountry}
        value={currentLocation?.countryId ||""}
        title={t("Selecione um item da lista.")}
        disabled={viewMode}
        style={{width: "295px"}}
      >
        <option  value="" selected>
          {t("Country...")}
        </option>
        {countries.map((item) => (
          <option key={item.id} value={item.id}>
            {t(item.description)}
          </option>
        ))}
      </Select>
    </div>
  </div>
  <div className="col-md-6">
    <div className={`form-group ${citySalaryLocationPosition(i18n.language)}`}>
      <div className="label-wrapper">
        {window.location.pathname.includes("createOrEdit") === true ? (
          <label htmlFor="cities">{t("City")}</label>
        ) : (
          <legend className="fontsize-legend">{t("City")}</legend>
        )}
      </div>
      <Select
      disabled={viewMode}
        required
        id="cityId"
        name="cityId"
        onChange={onChangeCity}
        value={currentLocation?.cityId||""}
        title={t("Selecione um item da lista.")}
      >
        <option  value="" selected>
          {t("City...")}
        </option>
        {cities.map((item) => (
          <option key={item.id} value={item.id}>
            {t(item.description)}
          </option>
        ))}
      </Select>
    </div>
  </div></div>
}